import {useEffect, useRef, useState} from "react"
import CardMenu from "../../components/card-menu";
import Menu from "./Menu";
import Alert from "../../components/alert";
import {enterprise_domains} from "../../config/tips";
import Text from "../../components/input/text";
import Select from "../../components/input/select";
import {protocols} from "../../config/selects";
import Checkbox from "../../components/input/checkbox";
import Button from "../../components/button";
import UseGetFormData from "../../hooks/UseGetFormData";
import {useNavigate} from "react-router-dom";
import {useEnterprise} from "./EnterpriseProvider";
import {UseGet, UsePost} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import {Card, Col, Row} from "react-bootstrap";
import {DomainDns} from "./DomainDns";

const DomainForm = () => {
    const formRef = useRef()
    const navigate = useNavigate()

    const {enterprise, domain} = useEnterprise();
    const idEnterprise = enterprise?._id?.$oid;
    const EnterpriseMenu = Menu({id: idEnterprise, domain})

    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [isMailSender, setIsMailSender] = useState(domain?.settings?.use_mail)
    const [dnsInfo, setDnsInfo] = useState([])


    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        setIsLoading(true)
        UsePost(
            `/domains/upsert/${domain ? domain?._id?.$oid : ''}`,
            {
                data: {
                    name           : FormData.get('name'),
                    protocol       : FormData.get('protocol'),
                    use_mail       : FormData.get('use_mail'),
                    email_subdomain: FormData.get('email_subdomain'),
                    id_enterprise  : idEnterprise,
                }
            }
        ).then((response) => {
            if (response.code >= 200 && response.code <= 299) {
                navigate(`/enterprises/${idEnterprise}/domains/${response.id}`)
                const action = domain ? 'updated' : 'created'
                UseMessage('success', `Domain has been successfully ${action}`)
                setErrors(undefined)
            } else {
                setErrors(response.errors)
            }
            setIsLoading(false)
        })
    }


    const checkDns = async (ev) => {
        ev.preventDefault()
        setIsLoading(true)

        const request = await UseGet(
            `/domains/${domain?._id?.$oid}/dns/check`,
            {data: {}}
        )

        if (request?.code >= 200 && request?.code < 299) {
            setDnsInfo(request?.message)
        }

        setIsLoading(false)
    }


    useEffect(() => {
        if(domain) setIsMailSender(domain?.settings?.use_mail)
    }, [domain]);

    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>
                                <CardMenu {...EnterpriseMenu} />

                                <Alert
                                    icon="info"
                                    docsPath="/docs/enterprises/domains"
                                    message={enterprise_domains}
                                />

                                <Text
                                    required
                                    size="sm"
                                    name="name"
                                    label="Domain name"
                                    isReady={!isLoading}
                                    value={domain?.name}
                                    error={errors?.name}
                                    placeholder="domain.com"
                                />

                                <Select
                                    required
                                    name="protocol"
                                    label="Protocol"
                                    isReady={!isLoading}
                                    options={protocols}
                                    error={errors?.protocol}
                                    value={domain?.settings?.use_ssl ? "https" : "http"}
                                />

                                {isMailSender &&
                                    <Text
                                        required
                                        size="sm"
                                        name="email_subdomain"
                                        label="Email subdomain"
                                        isReady={!isLoading}
                                        value={domain?.email_subdomain}
                                        error={errors?.email_subdomain}
                                        placeholder="mailer"
                                    />
                                }

                                <Checkbox
                                    name="use_mail"
                                    isReady={!isLoading}
                                    label="Use this domain as mail sender"
                                    value={domain?.settings?.use_mail ? "on" : "off"}
                                    onChange={(ev) => setIsMailSender(ev.target.checked)}
                                />


                                <div className="d-flex">
                                    <Button
                                        size="sm"
                                        icon="check"
                                        color="primary"
                                        isReady={!isLoading}
                                        className="mt-3 me-2"
                                        label={domain ? 'Update' : 'Create'}
                                    />

                                    {domain && <Button
                                        size="sm"
                                        icon="reload"
                                        label="Check Dns"
                                        color="secondary"
                                        isReady={!isLoading}
                                        className="mt-3"
                                        onClick={checkDns}
                                    />}
                                </div>
                                {dnsInfo?.length > 0 &&
                                    <DomainDns
                                        dnsInfo={dnsInfo}
                                        setDnsInfo={setDnsInfo}
                                        isLoading={isLoading}
                                    />
                                }
                            </form>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default DomainForm